import { combineReducers } from 'redux'

const rootReducer = combineReducers({
  account: require('./Account/reducer').reducer,
  auth: require('./Auth/reducer').reducer,
  store: require('./Store/reducer').reducer,
})

export default rootReducer
